// extracted by mini-css-extract-plugin
module.exports = {"article":"content_article__32SkD","focus":"content_focus__2NmWs","header":"content_header__2XNp2"};